import { gql } from "lib/apolloClient";

export const basicUserFragment = {
  user: gql`
    fragment userItem on User {
      id
      firstName
      middleName
      lastName
      email
      type
      profileImage
      ... on Staff {
        sourceId
      }
      ... on Student {
        sourceId
      }
    }
  `,
};
